// Page Home
export { default as ArticleSection } from './ArticleSection';
export { default as PropositionSection } from './PropositionSection';
export { default as ContactSection } from './ContactSection';

// Page Présentation
export { default as StorySection } from  './StorySection';
export { default as ComiteSection } from './ComiteSection';

// Page Politique
export { default as PolitiqueSection } from './PolitiqueSection';

// Page Publication
export { default as PublicationSection } from './PublicationSection';

// Page Article
export { default as ArticleByRub } from './ArticleByRub';

// Page Credit
export { default as CreditSection } from './CreditSection';